export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.36706f18dd8138a10fe4fbe923eb76e2.css";